import React from 'react';

class TableHead extends React.Component {
    render() {
        return (
            <thead>
            <tr>
                {
                    this.props.columns.map(function(cols, i) {
                        if (cols.visible === false) {
                            return;
                        }
                        return <th key={i}>{cols.label}</th>
                    })
                }
            </tr>
            </thead>
        );
    }
}

export default TableHead;